import {createMuiTheme} from '@material-ui/core'
import {corPrincipal, txtFocused} from '../variables'

const cor1 = corPrincipal

const selectedTabColor = cor1; 
const buttonColor = cor1

const theme = createMuiTheme({
  palette: {
    primary: {
      main: cor1,
    },
  },
  overrides: {
    MuiButton: {
    	root: {
      	backgroundColor: buttonColor,
      	color: 'white',
      	marginTop: '1rem',
		    fontFamily:'Roboto',
		    fontSize: '1.3rem',
		    fontWeight: 600,
		    '&:hover':{
		    	backgroundColor: buttonColor,
			    color: 'white',
			    fontFamily:'Roboto',
			    fontSize: '1.35rem',  
	    	}, 
			},
    },
    MuiTextField: {
    	root:{
		    marginTop: '1rem',
		    '& label.Mui-focused': {
		      color: txtFocused,
		    },
		    '& .MuiOutlinedInput-root': {
		      	'& fieldset': {
		        	borderColor: txtFocused,
		      	},
		      	'&:hover fieldset': {
		       		borderColor: txtFocused,
		      	},
	      		'&.Mui-focused fieldset': {
		        	borderColor: txtFocused,
		      	},
		    },
		  },
    },
    MuiTabs: {
    	indicator: {
    		backgroundColor: selectedTabColor,
    	},
    },
    MuiTab: {
    	root: { 
    		'&$selected': {  color: selectedTabColor, }, 
    	},
    },
  },
});

export default theme